module.exports = __webpack_public_path__ + "src/submodules/base/assets/img/spinner.7e637bbb.svg";